var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlugIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 5.5H15.75V1H14.25V5.5H9.75V1H8.25V5.5H7.5C6.67157 5.5 6 6.17157 6 7V11.5C6.0049 14.5209 8.25307 17.068 11.25 17.448V22H12.75V17.448C15.7469 17.068 17.9951 14.5209 18 11.5V7C18 6.17157 17.3284 5.5 16.5 5.5ZM16.5 11.5C16.5 13.9853 14.4853 16 12 16C9.51472 16 7.5 13.9853 7.5 11.5V7H16.5V11.5Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlugIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plug_in.576214e231a4e3f1fee22b8912aeb775.svg";